import React from 'react';

const NoDataFound = () => {
  return (
    <div className="flex items-center justify-center py-16 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full text-center border border-gray-200">
        <div className="flex justify-center mb-4 animate-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={72}
            height={72}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="text-gray-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 13h6m2 0a2 2 0 002-2V6a2 2 0 00-2-2H7a2 2 0 00-2 2v5a2 2 0 002 2m10 0v6a2 2 0 01-2 2H7a2 2 0 01-2-2v-6"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">No Data Available</h2>
        <p className="text-sm text-gray-500">We couldn’t find any results to show right now.</p>
      </div>
    </div>
  );
};

export default NoDataFound;
